import React, { useState } from 'react';
import api from '../../../api';
import styles from './PushNotificationDetails.module.css';
import TargetFilters from './TargetFilters/TargetFilters';
import Icon from '../../../campaigns/components/Icon';

const PushNotificationDetails = props => {
  const {
    pushNotificationDetails,
    setPushNotificationDetails,
    setPushNotificationToSendAgain
  } = props;
  const [isFetching, setIsFetching] = useState(false);
  const [
    pushNotificationDetailsList,
    setPushNotificationDetailsList
  ] = useState([]);
  const [error, setError] = useState(false);

  const getPushNotificationsDetail = () => {
    const getPushNotificationsDetailApi = async () => {
      setIsFetching(true);

      if (
        pushNotificationDetails &&
        pushNotificationDetails.attributes &&
        pushNotificationDetails.attributes.servicePushIds
      ) {
        const serviceDetails = await api().getPushNotificationsDetail(
          pushNotificationDetails.attributes.servicePushIds
        );

        if (
          serviceDetails &&
          serviceDetails.json &&
          serviceDetails.json.pushNotificationDetailsList
        ) {
          setPushNotificationDetailsList(
            serviceDetails.json.pushNotificationDetailsList
          );
          setError(false);
        } else {
          setError(true);
        }
      }

      setIsFetching(false);
    };

    getPushNotificationsDetailApi();
  };

  return (
    <div className={styles.detailsContainer}>
      <div
        className={styles.closeIconContainer}
        role="presentation"
        onClick={() => setPushNotificationDetails(null)}
      >
        <Icon type="close" />
      </div>
      <div className={styles.sectionTitle}>Title</div>
      <div className={styles.sectionDetails}>
        {pushNotificationDetails.attributes &&
          pushNotificationDetails.attributes.title}
      </div>
      <div className={styles.sectionTitle}>Description</div>
      <div className={styles.sectionDetails}>
        {pushNotificationDetails.attributes &&
          pushNotificationDetails.attributes.description}
      </div>
      <div className={styles.sectionTitle}>Target</div>
      <div className={styles.sectionDetails}>
        {(pushNotificationDetails.attributes &&
          pushNotificationDetails.attributes.count) ||
          'No details available'}
      </div>
      <div className={styles.sectionTitle}>Filter</div>
      <div className={styles.sectionDetails}>
        {pushNotificationDetails.attributes &&
        pushNotificationDetails.attributes.filter_string &&
        pushNotificationDetails.attributes.filter_string !== '[]' ? (
          <TargetFilters
            filterString={pushNotificationDetails.attributes.filter_string}
          />
        ) : (
          'No filters selected. Send push notification to all users!'
        )}
      </div>
      <div className={styles.sectionTitle}>Created At</div>
      <div className={styles.sectionDetails}>
        {pushNotificationDetails.attributes &&
          pushNotificationDetails.attributes.createdAt}
      </div>
      <div className={styles.footerContainer}>
        <div
          className={styles.sendPushButton}
          role="presentation"
          onClick={() => getPushNotificationsDetail()}
        >
          Get more details
        </div>
        <div
          className={`${styles.sendPushButton} ${styles.sendThisPushAgain}`}
          role="presentation"
          onClick={() => {
            setPushNotificationToSendAgain(pushNotificationDetails);
            setPushNotificationDetails(null);
          }}
        >
          Send this push again
        </div>
      </div>

      {!isFetching && pushNotificationDetailsList.length ? (
        <div className={styles.pushNotificationDetailsListContainer}>
          {pushNotificationDetailsList.map((listItem, index) => (
            <div
              className={styles.pushNotificationDetailsListItem}
              key={`push-notification-details-list-item-${index.toString()}`}
            >
              {JSON.stringify(listItem)}
            </div>
          ))}
        </div>
      ) : null}
      {!isFetching && error ? (
        <div className={styles.pushNotificationDetailsListContainer}>
          Error occured. Please contact administrator.
        </div>
      ) : null}
      {isFetching ? (
        <div className={styles.pushNotificationDetailsListContainer}>
          <div className={styles.pushNotificationDetailsListItem}>Loading</div>
        </div>
      ) : null}
    </div>
  );
};

export default PushNotificationDetails;
